<template>
    <v-dialog :model-value="dialog" max-width="400" @click:outside="$emit('close')" >
      <v-card>
        <v-card-title class="pt-4">Generate {{textToLowerCase}}</v-card-title>
        <v-card-text class="pt-0 pl-4">
          The current {{text}} will be replaced by an automatically generated {{textToLowerCase}}. <br><br>

          Are you sure you want to continue?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              :loading="loading"
              color="primary"
              text
              @click="$emit('generate')"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  <script>
  export default {
    name: 'GenerateDialog',
    props: {
      dialog: {default: false},
      loading: {},
      text: {default: ''},
    },
    computed: {
      textToLowerCase(){
        return this.text.toLowerCase()
      }
    }
  }
  </script>